module.exports = __webpack_public_path__ + "static/flags/EG-ca7e4933c66a3575e37fd9ebf6e45086.gif";